import React from 'react';
import './section11.css'
import cloud1 from '../../asserts/Group 31.png'
import cloud2 from '../../asserts/Group 57.png'

const  Sec11= () => {
    return ( 
        <section className="error-wrapper">
        <div className="error-card">

          <div className="wave-overlay"></div>
  

          <div className="text-group">
            <h1 className="error-title">Oops!</h1>
            <p className="error-subtitle">
              You can't seem <span>to</span> find the page you are looking for!
            </p>
          </div>
  

        </div>
      </section>
     );
}
 
export default Sec11;